var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 184,
    width: 30,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-998 -184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31354 17.4 12.1135 11.6 8.88125 11.6C9.93854 9.54583 12.0833 8.12604 14.5604 8.12604 16.1615 8.12604 17.6417 8.73021 18.7594 9.72708L24.65 9.72708C22.8677 5.92083 19.001 3.32292 14.5604 3.32292 9.39479 3.32292 5.04479 6.82708 3.77604 11.6L0.513542 11.6 6.31354 17.4Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5771 17.4 22.7771 11.6 16.9771 17.4 20.2396 17.4C19.1823 19.4542 17.0375 20.874 14.5604 20.874 12.9594 20.874 11.4792 20.2698 10.3615 19.2729L4.44063 19.2729C6.25313 23.0792 10.0896 25.6771 14.5604 25.6771 19.726 25.6771 24.076 22.1729 25.3448 17.4L28.5771 17.4Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 184)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess);
export default __webpack_public_path__ + "static/media/IconProcess.b5d632bc5c5590729c35609900d6d585.svg";
export { ForwardRef as ReactComponent };